import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ufolog } from '@atlassian/ufo-experimental/logger';
import { SUBSCRIBE_ALL, UFOGlobalEventStreamEventType } from '@atlassian/ufo-experimental/types';
export class UFOGlobalEventStream {
  constructor() {
    _defineProperty(this, "__buffer_only__", false);
    _defineProperty(this, "subscribers", {});
  }
  push(event) {
    ufolog('EVENT STREAM push', event.type, event.payload);
    if (event.type === UFOGlobalEventStreamEventType.EXPERIENCE_PAYLOAD) {
      this.publish(event.payload);
    }
    if (event.type === UFOGlobalEventStreamEventType.SUBSCRIBE) {
      this.subscribe(event.payload.experienceId, event.payload.callback);
    }
    if (event.type === UFOGlobalEventStreamEventType.UNSUBSCRIBE) {
      this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
  }
  publish(eventPayload) {
    var _this$subscribers$eve;
    if (this.subscribers[SUBSCRIBE_ALL]) {
      this.subscribers[SUBSCRIBE_ALL].forEach(fn => {
        fn(eventPayload);
      });
    }
    (_this$subscribers$eve = this.subscribers[eventPayload.id]) === null || _this$subscribers$eve === void 0 ? void 0 : _this$subscribers$eve.forEach(fn => {
      fn(eventPayload);
    });
  }
  subscribe(experienceId, fn) {
    ufolog('EVENT STREAM subscribe', experienceId);
    if (!this.subscribers[experienceId]) {
      this.subscribers[experienceId] = [];
    }
    this.subscribers[experienceId].push(fn);
  }
  unsubscribe(experienceId, fn) {
    const index = this.subscribers[experienceId].findIndex(entry => entry === fn);
    if (index !== -1) {
      this.subscribers[experienceId].splice(index, 1);
    }
  }
}